import { createFileRoute } from '@tanstack/react-router'
import { SettingsAgentKeys } from '@/features/settings/agent-keys'

export const Route = createFileRoute('/_authenticated/settings/agent-keys')({
  component: SettingsAgentKeys,
})
